export class Prettier {
  static defaultOptions = {
    prettier: true,
    prettierOptions: {
      settings: {
        singleQuote: true,
      },
    },
  };
}
